import { NgModule } from '@angular/core';

import { StoreModule } from '@ngrx/store';

import { COMMON_FEATURE_KEY, INSTANT_SEARCH_FEATURE_KEY } from './constants';
import { reducers } from './reducers';
import { instantSearchReducer } from './reducers/instant-search.reducer';

@NgModule({
  imports: [
    StoreModule.forFeature(COMMON_FEATURE_KEY, reducers),
    StoreModule.forFeature(INSTANT_SEARCH_FEATURE_KEY, instantSearchReducer),
  ],
})
export class CommonStoreModule {}
